import React, { useEffect, useState } from 'react';
import {Empty, Spin} from 'antd';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

/**
 * A wrapper around ag-grid react with standard properties for convinence.
 */

export default props => (
    <div className="ag-theme-balham" style={styles.gridContainer}>
        <AgGridReact
            rowGroupPanelShow="always"
            animateRows
            enableFilter
            floatingFilter
            enableSorting
            enableColResize
            defaultColDef={{
                sortable: true,
                resizable: true
            }}
            frameworkComponents={{
                customNoRowsOverlay: () => <Spin />,
            }}
            onFirstDataRendered={params => {
                params.columnApi.autoSizeAllColumns();
            }}
            overlayLoadingTemplate={
                '<span className="ag-overlay-loading-center">Please wait while your rows are loading...</span>'
              }
            noRowsOverlayComponent="customNoRowsOverlay"
            loadingOverlayComponent="customLoadingOverlay"
            {...props}
        />
    </div>
);

const styles = {
    gridContainer: {
        flex: 1,
    },
};
